import styled from "styled-components";

export const SortableTh = styled.th`
  cursor: pointer;
  user-select: none;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
`;

export const SortIndicator = styled.span<{ $active?: boolean }>`
  display: inline-block;
  margin-left: 6px;
  font-size: 10px;
  width: 8px;
  opacity: ${({ $active }) => ($active ? 0.95 : 0.45)};
`;
